// @ts-ignore
import ContentModal from "@ContentModal";
var modalMixin = {
    components: {
        ContentModal: ContentModal
    },
    methods: {
        triggerModal: function (modalContents) {
            var modalWidth = (this.$mq === 'mobile') ? '100%' : '65%';
            var events = modalContents.events || {};
            var modalName = modalContents.modalName || 'contentModal';
            this.$modal.show(ContentModal, {
                contentTemplate: modalContents.contentTemplate || "",
                contentComponent: modalContents.component,
                contentProperties: modalContents.contentProperties || null,
                header: {
                    title: modalContents.title,
                    showBackButton: (modalContents.hasOwnProperty("showBackButton")) ? modalContents.showBackButton : false,
                    showCloseButton: (modalContents.hasOwnProperty("showCloseButton")) ? modalContents.showCloseButton : true,
                    showHeader: modalContents.hasOwnProperty("showHeader") ? modalContents.showHeader : true
                },
                footer: {
                    showFooter: (modalContents.hasOwnProperty("showFooter")) ? modalContents.showFooter : false,
                },
                modalName: modalName,
            }, {
                name: modalName,
                width: modalWidth,
                height: 'auto',
                scrollable: true,
                clickToClose: false,
                delay: 200,
                classes: modalContents.classes || ""
            }, events);
        },
    }
};
export default modalMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/modalMixin.ts
// module id = b+m4
// module chunks = 18